export const getPdfBinaryKey = (id: string) => `PDF_${id}_PDF`;
